import React, { useContext, useEffect, useState } from "react";
import { RulesContext } from "./RulesContext";
import RuleHeader from "./Components/RuleHeader";
import RuleCategorySelector from "./Components/RuleCategorySelector";
import RuleBody from "./Components/RuleBuilder/RuleBody";
import { CBA_RULE, CBI_RULE, CBM_RULE } from "./misc/RuleObjectTypes";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import CBMCategorySelector from "./Components/CBMCategorySelector";
import MatrixComponent from "./Components/CBM_rule_BUilder/Matrix/MatrixComponent";
import { useHistory } from "react-router-dom";
import CompatioLoader from "Components/Common/components/CompatioLoader";
import { AppContext } from "Context/AppContext";
import { toast } from "react-toastify";
import { parseJson } from "Common/HelperClass";
import { CBM } from "Pages/GMS/ISR/ISRConstants";


function RulesAddEditManage({ ruleId, type }) {
  const history = useHistory();
  const {
    ruleType,
    selectedCategories,
    setSelectedCategories,
    attributesList,
    Loading,
    setLoading,
    ruleDispatch,
    CBMOptions,
    setCBMOptions,
    loadMasterdata,
    setCellStates,
    setCompatibilityData,
    setCbmRuleId,
    setInitialRuleDetails,
  } = useContext(RulesContext);
  const {
    leftCatListOption,
    rightCatListOption,
    leftCatAttributeSet,
    rightCatAttributeSet,
    rightValuesAttr,
    leftValuesAttr,
  } = CBMOptions;
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [editPage, setEditPage] = useState(false);
  const [ruleDetails, setRuleDetails] = useState(null);
  const [ruleHeaderDetails, setRuleHeaderDetails] = useState({ name: "", rule_type: null, rule_status: 0, description: "", asymmetric: false });
  let appContext = useContext(AppContext);
  let industryId =
    appContext &&
    appContext?.get_selected_industry() &&
    appContext?.get_selected_industry()?.id;
  let channelKey = appContext?.channelKey;
  useEffect(() => {
    setCbmRuleId(ruleId);
    if (ruleId.includes("_duplicate")) {
      setEditPage(false);
      load_Rule_Details(ruleId.replace("_duplicate", ""), true);
    } else if (ruleId && ruleId !== "0" && type === "copy") {
      setEditPage(false);
      load_Rule_Details(ruleId);
    } else if (ruleId && ruleId !== "0") {
      setEditPage(true);
      load_Rule_Details(ruleId);
    } else {
      setEditPage(false);
    }
  }, [ruleId]);

  const getCellStateFromRuleBody = (rule_body) => {
    return rule_body?.rule?.rule?.reduce((acc, item) => {
      const key =
        rule_body?.leftCatCompatibilityType === "values"
          ? `${item.leftValueId}-${item.rightValueId}`
          : `${item.leftProdId}-${item.rightProdId}`;
      const numericValue = convertToNumeric(item.compatibility);
      acc[key] = numericValue;
      return acc;
    }, {});
  }

  const load_Rule_Details = async (ruleId, duplicatePage = false) => {
    try {
      setLoading({ status: "Loading", message: "Loading Rules details" });
      let ret = await ServiceWrapper.doGet(
        `${api_base_url}rule/list?page=1&per_page=1&industry_id=${industryId}&channel_key=${channelKey}&ruleid=${ruleId}`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!ret.errorfound) {
        if (ret?.data?.data?.length === 0) {
          toast.info("Rule not found");
          history.push("/gms/rules/list");
        }
        let ruleDet = ret.data.data[0];
        let rule_body = parseJson(ruleDet?.rule_body);

        ruleDet = { ...ruleDet, rule_body };
        if (ruleDet.rule_type === CBM
          && Object.keys(rule_body?.cellStates).length === 0
          && rule_body?.cellStates?.constructor === Object) {
          const convertedData = getCellStateFromRuleBody(rule_body)
          if (convertedData) {
            ruleDet.rule_body.cellStates = convertedData
          }
        }
        if (duplicatePage) {
          const name = ruleDet.name + " [Duplicate]";
          const description = ruleDet.description + " [Duplicate]";
          ruleDet = {
            ...ruleDet,
            name: name,
            description: description,
            commit: false,
            rule_status: 0,
          };
        }
        setRuleDetails(ruleDet);
        setInitialRuleDetails(JSON.parse(JSON.stringify(ruleDet)));
        updateRuleBody(ruleDet);
        setLoading({ status: "Success", message: undefined });
        if (!duplicatePage && type === "edit") {
          setEditPage(true);
        }
      } else {
        setLoading({ status: "Error", message: "Error while Loading Rules" });
      }
    } catch (error) {
      console.error("load_Rule_Details ~ error:", error);
    }
  };

  const updateRuleBody = (ruleBody) => {
    if (ruleBody && ruleBody.rule_type === CBM_RULE) {
      const {
        left_category,
        right_category,
        left_category_name,
        right_category_name,
        rule_body,
      } = ruleBody;
      const {
        compatibilityLevel,
        leftCatCompatibilityType,
        rightCatCompatibilityType,
        defaultCompatibilityValue,
        leftAttributeId,
        rightAttributeId,
        leftValuesAttrName,
        rightValuesAttrName,
        leftAttributeValueId,
        leftAttributeValueName,
        rightAttributeValueId,
        rightAttributeValueName,
        isProductFilter,
        cellStates,
      } = ruleBody.rule_body;

      setSelectedCategories({
        leftCategory: { id: left_category, name: left_category_name },
        rightCategory: { id: right_category, name: right_category_name },
      });
      setCBMOptions((prev) => {
        return {
          ...prev,
          leftCatListOption: leftCatCompatibilityType,
          rightCatListOption: rightCatCompatibilityType,
          leftValuesAttr: leftAttributeId,
          rightValuesAttr: rightAttributeId,
          defaultCompatibilityValue: defaultCompatibilityValue,
          compatibilityLevel: compatibilityLevel,
          leftCatID: left_category,
          rightCatID: right_category,
          leftValuesAttrName,
          rightValuesAttrName,
          leftAttributeValueId,
          leftAttributeValueName,
          rightAttributeValueId,
          rightAttributeValueName,
          isProductFilter,
        };
      });
      const convertedData = getCellStateFromRuleBody(rule_body)
      if (convertedData) {
        setCellStates(convertedData);
      }

      setCompatibilityData(rule_body?.rule?.rule ?? []);
      ruleDispatch({ type: "CBM_RULE_TYPE", data: rule_body.rule.rule });
    } else {
      const {
        left_category,
        right_category,
        left_category_name,
        right_category_name,
      } = ruleBody;
      setSelectedCategories({
        leftCategory: { id: left_category, name: left_category_name },
        rightCategory: { id: right_category, name: right_category_name },
      });
    }
  };

  const convertToNumeric = (compatibility) => {
    switch (compatibility) {
      case "good":
        return 1;
      case "better":
        return 2;
      case "best":
        return 3;
      default:
        return 0;
    }
  };

  const isViewMode = type === "view";

  return (
    <>
      {isViewMode ? (
        <RuleHeader
          ruleDetails={ruleDetails}
          editPage={editPage}
          load_Rule_Details={load_Rule_Details}
          loading={Loading}
          type={type}
          isViewMode={isViewMode}
          setRuleDetails={setRuleDetails}
          ruleHeaderDetails={ruleHeaderDetails}
          setRuleHeaderDetails={setRuleHeaderDetails}
        />
      ) : null}

      <div
        style={
          isViewMode
            ? {
              pointerEvents: "none",
              opacity: 0.6,
              userSelect: "none",
            }
            : {}
        }
      >
        {
          <>
            {((ruleDetails && editPage) || !editPage) && !isViewMode ? (
              <RuleHeader
                ruleDetails={ruleDetails}
                editPage={editPage}
                load_Rule_Details={load_Rule_Details}
                loading={Loading}
                type={type}
                setRuleDetails={setRuleDetails}
                ruleHeaderDetails={ruleHeaderDetails}
                setRuleHeaderDetails={setRuleHeaderDetails}
              />
            ) : null}
            {((editPage && !ruleDetails) || !loadMasterdata) && (
              <div className="pt-0">
                <CompatioLoader />
              </div>
            )}
            {((ruleDetails && editPage) || !editPage) && loadMasterdata && (
              <>
                {(ruleType === CBI_RULE || ruleType === CBA_RULE) && (
                  <RuleCategorySelector
                    ruleBody={ruleDetails && ruleDetails.body}
                    ruleDetails={ruleDetails}
                    setRuleDetails={setRuleDetails}
                    ruleHeaderDetails={ruleHeaderDetails}
                    setRuleHeaderDetails={setRuleHeaderDetails}
                    type={type}
                  />
                )}
                {ruleType === CBM_RULE && (
                  <CBMCategorySelector
                    ruleBody={ruleDetails && ruleDetails.body}
                    ruleId={ruleId}
                    load_Rule_Details={load_Rule_Details}
                    type={type}
                    commit={ruleDetails?.commit}
                  />
                )}

                <div className="tw-space-y-5">
                  {(ruleType === CBI_RULE || ruleType === CBA_RULE) &&
                    attributesList.leftAttributes !== null &&
                    attributesList.rightAttributes !== null && (
                      // ruleType === CBA_RULE &&
                      <>
                        <RuleBody
                          ruleBody={ruleDetails && ruleDetails?.rule_body?.rule}
                        />
                        <div className="">
                          <button
                            className="outline-button tw-mb-6"
                            type="button"
                            name="Add Condition"
                            onClick={() =>
                              ruleDispatch({ type: "ADD_CONDITIONAL" })
                            }
                          >
                            Add condition
                          </button>
                        </div>
                        {/* <button
                        className="btn btn-outline-primary btn-sm ms-4"
                        style={{ fontWeight: "bold", fontSize: ".7rem" }}
                        onClick={() =>
                          ruleDispatch({ type: "ADD_CONDITIONAL" })
                        }
                      >
                        Add Condition
                      </button> */}
                      </>
                    )}

                  {ruleType === CBM_RULE &&
                    selectedCategories.leftCategory.id &&
                    selectedCategories.rightCategory.id &&
                    leftCatListOption &&
                    rightCatListOption &&
                    ((leftCatListOption === "values" &&
                      leftCatAttributeSet.length > 0 &&
                      leftValuesAttr) ||
                      leftCatListOption === "products") &&
                    ((rightCatListOption === "values" &&
                      rightCatAttributeSet.length > 0 &&
                      rightValuesAttr) ||
                      rightCatListOption === "products") ? (
                    <div className="cbm-rule-builder">
                      <MatrixComponent />
                    </div>
                  ) : null}
                </div>
              </>
            )}
          </>
        }
      </div>
    </>
  );
}

export default RulesAddEditManage;
